import { Field } from '../ui/Field';
import { NumberInput } from '../ui/NumberInput';
type Props = {
  label: string;
  hint?: string;
  value: number;
  onChange: (value: number) => void;
  /** Bedragen in euro's ("12,50"). */
  decimals?: boolean;
  min?: number;
  max?: number;
};

/** Eén getal in Instellingen: label met eenheid, korte uitleg, en een veld dat nooit iets ongeldigs bewaart. */
export function SettingNumber({
  label,
  hint,
  value,
  onChange,
  decimals,
  min,
  max
}: Props) {
  return <Field label={label} hint={hint} data-id="element-4314" data-mp="1k63ltruvby7k">
      <NumberInput value={value} onChange={n => {
      if (n !== undefined) onChange(n);
    }} decimals={decimals} min={min} max={max} className="sm:max-w-[11rem]" data-id="element-4315" data-mp="1fdanblpztm3x" />
    </Field>;
}